<app-layout columnCount="12" maxWidth="70rem">
  <app-layout-title>
    <app-go-back-button (click)="goBack()">
      {{ 'ADMIN.user_projects' | translate:{ name: user.fullName } }}
    </app-go-back-button>
  </app-layout-title>

  <app-layout-content>
    <div class="projects-list">
      @for (project of assignedProjects; track project) {
        <mat-checkbox [(ngModel)]="project.isAssigned">
          <app-project-view [name]="project.name" [iso]="project.isoCode"></app-project-view>
        </mat-checkbox>
      }
    </div>

    <app-button-group>
      <app-yes-no (action)="assignProjects()" (cancel)="goBack()" [actionName]="'ADMIN.assign' | translate"></app-yes-no>
    </app-button-group>
  </app-layout-content>
</app-layout>
